import type { Ref } from 'vue';

export interface PhoneNumbers {
  usCallers?: string;
  internationalCallers?: string;
}

export interface PhoneEntry {
  type: 'us' | 'international' | 'text';
  label: string;
  phoneNumber?: string;
  telUrl?: string;
  text?: string;
}

export function usePhoneInteraction(helpCenterNumbers: Ref<PhoneNumbers>) {

  const formatPhoneNumbers = (sideText: string | null): PhoneEntry[] => {
    if (!sideText) return [];

    // get phone numbers from props for call to action links
    const usPhone = helpCenterNumbers.value.usCallers || 'NA';
    const intlPhone = helpCenterNumbers.value.internationalCallers || 'NA';

    // split by tilde and process each phone number entry
    const phoneEntries = sideText.split('~');

    return phoneEntries.map((entry): PhoneEntry => {
      if (entry.includes('U.S. callers:')) {
        const phoneNumber = entry.replace('U.S. callers: ', '').trim();
        return {
          type: 'us',
          label: 'U.S. callers:',
          phoneNumber,
          telUrl: `tel:+${usPhone.replace(/-/g, '')}`
        };
      }
      if (entry.includes('International callers:')) {
        const phoneNumber = entry.replace('International callers: ', '').trim();
        return {
          type: 'international',
          label: 'International callers:',
          phoneNumber,
          telUrl: `tel:+${intlPhone.replace(/-/g, '')}`
        };
      }
      return {
        type: 'text',
        label: '',
        text: entry
      };
    });
  };

  const callPhone = (phoneNumber: string): void => {
    const cleanNumber = phoneNumber.replace(/-/g, '');
    const url = `tel:+${cleanNumber}`;
    window.location.href = url;
  };

  return {
    formatPhoneNumbers,
    callPhone,
  };
}
